import individualWorkSupportUtil from '../../../../../share/util/individualWorkSupportUtil';
import session from '../../../../../share/session';
import { REQUEST_STATUS_COMPLETED, REQUEST_STATUS_FAILED } from '../../../../../share/util/api/polling';
import { terminate } from './terminate';

/**
 * 暗号鍵一致確認
 * @param {object} self this インスタンス
 * @param {string} nextPhase 遷移先のphase
 * @param {string} failedPhase 失敗時に遷移先のphase
 */
export async function checkKeys(self, nextPhase, failedPhase) {
  try {
    self.isLoading = true;
    const token = session.getToken();
    const response = await individualWorkSupportUtil.pollingWspApi(
      self,
      self.netAppId,
      self.systemId,
      self.workSupportId,
      {
        id_token: token.id_token,
        is_special: true,
        type: 'check_keys'
      },
      // エラー発生のコールバック
      async (errorType) => { errorType; await self.showUnexpectedError(); },
      // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
      async (result) => { await self.validateErrorResult(result); },
      // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
      async (result) => { await self.validateErrorResult(result); }
    );

    if (response) {
      switch (response.data.status) {
        case REQUEST_STATUS_COMPLETED:
          // 表のリセット
          self.historyListCurrentSort = '';
          self.historyListSortDir = '';
          self.historyList.forEach(i => {
            i.selected = false;
          });
          self.previewSelectCurrentSort = '';
          self.previewSelectSortDir = '';
          self.selectedPreviewItem = null;
          self.previewList.forEach(item => {
            if (item.fieldSpec) {
              delete item.fieldSpec;
            }
          });
          self.phase = nextPhase;
          break;
        case REQUEST_STATUS_FAILED:
        default:
          await terminate(self, failedPhase);
          break;
      }
    }
  } finally {
    self.isLoading = false;
  }
}